window.orderSummary = {
  resizeCells: resizeCells,
  initRetractableInfo: initRetractableInfo,
  initSimpleRetraction: initSimpleRetraction,
}

function resizeCells() {
  const list = document.querySelector(".order-summary__list")

  if (!list) {
    return
  }

  resizeCell(list, "size")
  resizeCell(list, "model")
  resizeCell(list, "color")
  resizeCell(list, "handle")
  resizeCell(list, "amount", true)
  resizeCell(list, "price")
}

function resizeCell(list, name, resizeChild = false) {
  // legacy
  return

  const elements = Array.from(
    list.querySelectorAll(`.order-line-item__body .info--${name}`),
  ).filter((element) => {
    const style = getComputedStyle(element)

    return style.display !== "none"
  })

  let maxWidth = Number.NEGATIVE_INFINITY

  for (const element of elements) {
    const childElement = element.querySelector(".info__name span")

    element.style.width = null
    childElement.style.width = null

    if (childElement.offsetWidth > maxWidth) {
      maxWidth = childElement.offsetWidth
    }
  }

  for (const element of elements) {
    if (resizeChild) {
      const childElement = element.querySelector(".info__name span")
      childElement.style.width = `${maxWidth + 1}px`
    } else {
      element.style.width = `${maxWidth + 1}px`
    }
  }
}

function initRetractableInfo() {
  const header = document.querySelector(
    ".order-summary__section--fronts-summary h3",
  )
  if (!header) return

  const firstSummaryRow = document.querySelector(
    ".order-summary__section--fronts-summary .info-grid .info--first-row",
  )

  header.style.cursor = "pointer"
  header.classList.add("expandable-header")

  const infoGrid = document.querySelector(
    ".order-summary__section--fronts-summary .info-grid",
  )
  if (!infoGrid) return

  const allInfos = Array.from(infoGrid.querySelectorAll(".info"))
  const summaryInfos = allInfos.slice(0, 2) // First pair (summary)
  const retractableInfos = allInfos.slice(2) // All other pairs

  retractableInfos.forEach((info) => {
    info.classList.add("retractable")
    info.style.display = "none"
  })

  header.addEventListener("click", () => {
    const isExpanded = header.classList.contains("expanded")

    if (isExpanded) {
      // Retract
      retractableInfos.forEach((info) => {
        info.style.display = "none"
      })
      header.classList.remove("expanded")
      firstSummaryRow.style.marginBottom = "0"
    } else {
      // Expand
      retractableInfos.forEach((info) => {
        info.style.display = "block"
      })
      header.classList.add("expanded")
      firstSummaryRow.style.marginBottom = "10px"
    }
  })

  header.click()
}

function initSimpleRetraction() {
  const header = document.querySelector(
    ".order-summary__section .simple-expandable-header",
  )
  if (!header || header.getAttribute("data-disabled")) return

  const isExpanded = header.classList.contains("expanded")
  header.style.cursor = "pointer"

  const target = document.getElementById(header.getAttribute("data-target"))

  if (!isExpanded) {
    target.style.display = "none"
  }

  header.addEventListener("click", () => {
    const isExpanded = header.classList.contains("expanded")

    if (isExpanded) {
      // Retract
      target.style.display = "none"
      header.classList.remove("expanded")
    } else {
      target.style.display = "block"
      header.classList.add("expanded")
    }
  })
}

window.addEventListener("load", () => {
  resizeCells()
  initRetractableInfo()
  initSimpleRetraction()
})

window.addEventListener("resize", () => {
  resizeCells()
})
